import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForUserComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'name',
    'description',
    'userRoles',
    'lastLoginTime',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'description',
      sortable: true,
      isTruncate: true,
    },
    {
      property: 'userRoles',
      type: 'relation',
    },
    {
      property: 'lastLoginTime',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
